












































import { Component, Prop } from 'vue-property-decorator';
import { ProductWizardModule } from '@/store/Products/ProductWizardModule';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVueProductForm from '@/components/Shared/SaascadaVueProductForm';
import ListUtils from '@/lib/listUtils';
import FieldLabel from '@/components/Shared/FieldLabel.vue';

@Component({ name: 'GeneralProductSettingsEdit', components: { FieldLabel } })
export default class extends SaascadaVueProductForm {

    @Prop({ required: true })
    isCreate: boolean

    get productVM() {
        if (this.isCreate) {
            return ProductWizardModule.createProductViewModel;
        }
        return ProductDetailsModule.productVM;
    }

    get currencyOptions() {
        return AuthModule.me.institution.config.availableCurrencies;
    }

    get targetCustomerTypeOptions() {
        return ListUtils.targetCustomerTypeOptions();
    }

}
